import { useMemo } from "react"
import { APIAppAsyncOperationModel } from "../Models/API/APIAppAsyncOperationModel"
import { hasValue } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"

export const useJobPostProcessAsyncOperation = (
    appID: string,
    jobUuid?: string
): APIAppAsyncOperationModel | undefined => {
    const fetchState = useAppState(
        state => state.api.apps.asyncOperation[appID]
    )

    return useMemo(() => {
        if (!hasValue(fetchState) || jobUuid === undefined) {
            return
        }
        return fetchState.value.find(op => op.jobUuid === jobUuid)
    }, [fetchState, jobUuid])
}
